document.addEventListener('DOMContentLoaded', () => {
  // 1. Reveal Elements with Smooth Intersection Entry
  const revealOptions = {
    threshold: 0.15,
    rootMargin: "0px 0px -50px 0px"
  };

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target); // Stop checking once shown
      }
    });
  }, revealOptions);

  // Select both narrative points and images
  const targets = document.querySelectorAll('.animate-trigger, .animate-trigger-media');
  targets.forEach(el => revealObserver.observe(el));


  // 2. Premium Scroll Parallax Action for Media Blocks
  window.addEventListener('scroll', () => {
    const mediaContainer = document.querySelector('.sensory-media-wrapper');
    if (!mediaContainer) return;

    const scrolled = window.pageYOffset;
    const containerTop = mediaContainer.offsetTop;
    const windowHeight = window.innerHeight;

    // Run calculations only if section enters viewport bounds
    if (scrolled + windowHeight > containerTop && scrolled < containerTop + mediaContainer.offsetHeight) {
      const shiftValue = (scrolled + windowHeight - containerTop) * 0.04;
      
      const primaryImg = document.querySelector('.block-primary img');
      const secondaryBlock = document.querySelector('.block-secondary');

      if (primaryImg) {
        primaryImg.style.transform = `scale(1.05) translateY(${-shiftValue * 0.3}px)`;
      }
      if (secondaryBlock) {
        // Pushes secondary layout opposite to build rich depth
        secondaryBlock.style.transform = `translateY(${-shiftValue * 0.6}px)`;
      }
    }
  });
});